<marketplace-header> </marketplace-header>

<div class="container">
  <div>
    <div class="message-box">
      <ate-image alt="404" src="assets/ate-not-found/marquee-illustration.svg"> </ate-image>
      <h3>
        {{ message?.header }}
      </h3>
      <p>
        {{ message?.subheader }}
      </p>
    </div>

    <a *ngIf="message?.buttonText && message?.url" ate-button expand="block" [routerLink]="[this.message.url]" hollow="true">
      {{ message?.buttonText }}
    </a>
  </div>
</div>
